// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 513 ? "photo-editor" : chunkId) + "." + {"426":"e3e37f4d","513":"0d3a65a7"}[chunkId] + ".chunk.css";
};